<template>
  <div class="s-bg-white rounded rounded-2 d-flex align-items-center list__item"
    @click="$router.push({ name: 'LiffMemberCardPartnetPointShow', params: { partner_org_hashid: item.partner_org_hashid } })">
    <div class="list__image px-3">
      <img :src="require(`@/pages/Liff/MemberCard/PartnetPoint/images/${item.image}`)" alt="">
    </div>
    <div class="flex-fill  px-3">
      <div class="list__title mb-2">{{ item.title }}</div>
      <div v-for="(j, jdx) in item.exchange" :key="jdx" class="s-text-xs mb-1 list__exchange">
        <span class="s-text-primary font-weight-bold">{{ j.from.value }}</span>{{ j.from.unit }}→<span
          class="s-text-primary  font-weight-bold">{{ j.to.value }}</span>{{ j.to.unit }}
      </div>
      <div v-if="item.more" class="s-text-xs badge badge-secondary p-1">更多方案</div>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {

  },
}
</script>
<style lang="scss" scoped>
.list {



  &__image {
    border-right: 1px solid #E3E3E3;

    img {
      max-width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__title {
    font-weight: 500;
    font-size: 16px;
    color: black;
  }

  &__exchange {
    font-weight: 500;
    font-size: 14px;
    color: #666666;
  }

  &__item {
    margin-bottom: 12px;
    padding: 8px 0;
    box-shadow: 0px 2px 6px 0px #00000033;

  }


}
</style>